<div class="row option-row">
  <div class="col-xs-12 col-sm-6 col-md-2 interest-rate">
    {{option.effectiveRateOfInterest | round: 2}}%
    <span class="interest-rate-text">Interest</span>
  </div>

  <div class="col-xs-12 col-sm-6 col-md-4">
    <p class="emi">{{option.emi | round | indianCurrency}} x {{option.tenure}} months</p>
    <p class="savings" *ngIf="!option.subventedAmount">Prepay anytime without any charges</p>
  </div>

  <div class="clearfix visible-sm"></div>

  <div class="col-xs-6 col-md-3 col-lg-2 col-lg-offset-1">
    <p class="loan-amount">{{option.amount | round | indianCurrency}}</p>
    <p class="loan-amount-label">Loan amount</p>
  </div>

  <div class="col-xs-6 col-md-3 apply-button-container">
    <button mat-flat-button class="button-forward primary apply-button" (click)="apply(option)">Apply</button>
  </div>
</div>
